import type { Response } from '../extended-express-types';
import { TaskNumberModel } from '../models/task-number.model';
import type { Org, OrgSpace, OrgUser } from '../types/org-types';
import { generateId } from './utils.service';

export function getSpace({
  org,
  spaceId,
  res,
}: {
  org: Org;
  spaceId: string;
  res: Response;
}) {
  const space = org.spaces.find((s) => s._id === spaceId);
  if (!space) {
    res.status(404);
    throw new Error('spaceId not found');
  }
  return space;
}

export function getUserSpaces(spaces: OrgSpace[], userId: string) {
  return spaces.filter((space) => space.users.find((u) => u._id === userId));
}

export function checkSpaceAccess({
  space,
  user,
  res,
}: {
  space: OrgSpace;
  user: OrgUser;
  res: Response;
}) {
  const found = space.users.find((u) => u._id === user._id);
  if (found) return;
  if (user.admin) return;
  res.status(403);
  throw new Error('Unauthorized: userId not in spaceId');
}

export async function createTaskNumber({
  orgId,
  spaceId,
}: {
  orgId: string;
  spaceId: string;
}) {
  const taskNumber = await TaskNumberModel.create({
    _id: generateId(),
    orgId,
    spaceId,
    taskNumber: 0,
  });
  return taskNumber;
}

export async function incrementTaskNumber({
  orgId,
  spaceId,
}: {
  orgId: string;
  spaceId: string;
}) {
  const result = await TaskNumberModel.findOneAndUpdate(
    { orgId, spaceId },
    { $inc: { taskNumber: 1 } },
    { runValidators: true, returnDocument: 'after' }
  );
  if (!result) throw new Error('TaskNumber could not be incremented');
  return result.taskNumber;
}
